export default __webpack_public_path__ + "assets/images/a73a3a8ad1164bcf869be06c0b918c4a.svg";